import { makeStyles, Theme } from '@material-ui/core/styles'
import {
  colorBlackAlpha50,
  elevatedSurfaceBoxShadow,
  transition,
} from '../../shared/style-settings'

export const useOrderPageStyles = makeStyles((theme: Theme) => ({
  pageHolder: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  },
  container: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  },
  breadcrumbs: {
    marginBottom: theme.spacing(2),
  },
  loaderBlock: {
    padding: theme.spacing(2.5, 0),
  },
  card: {
    borderRadius: theme.shape.borderRadius * 2,
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.shape.borderRadius,
    },
  },
  orderHeader: {
    padding: theme.spacing(4, 3),
    backgroundColor: theme.palette.grey[50],
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 2),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 1.5),
    },
  },
  badgeHolder: {
    position: 'absolute',
    display: 'block',
    top: -8,
    right: -20,
    [theme.breakpoints.down('sm')]: {
      top: -6,
      right: -15,
    },
    '& .MuiBadge-badge': {
      borderRadius: theme.shape.borderRadius,
      fontSize: '0.75rem',
      fontWeight: 600,
      padding: theme.spacing(0.5, 1),
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.6875rem',
        padding: theme.spacing(0.4, 0.8),
      },
    },
  },
  dividerHolder: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  orderHeaderTitle: {
    marginRight: theme.spacing(6),
    position: 'relative',
    display: 'inline-block',
  },
  orderHeaderStatusText: {
    color: colorBlackAlpha50,
  },
  orderBody: {
    padding: theme.spacing(4, 3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 2),
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 1.5),
    },
  },
  orderBodyHolder: {},

  //Price Info
  orderPriceInfo: {
    borderRadius: theme.shape.borderRadius * 2,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: elevatedSurfaceBoxShadow,
    backgroundColor: theme.palette.background.paper,
    transition: transition,
    '&:hover': {
      boxShadow: elevatedSurfaceBoxShadow,
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.shape.borderRadius,
    },
  },
  orderPriceInfoTitle: {
    textAlign: 'center',
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
    '& .MuiTypography-h5': {
      fontSize: '2rem',
      fontWeight: 700,
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.75rem',
      },
    },
  },
  orderPriceInfoSubtitle: {
    fontWeight: 400,
    fontSize: '0.875rem',
    marginTop: theme.spacing(0.5),
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8125rem',
    },
  },
  orderPriceInfoBody: {
    borderRadius: theme.shape.borderRadius,
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
  },
  orderPriceInfoBodyItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.25),
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  orderPriceInfoBodyItemLabel: {
    fontWeight: 500,
    fontSize: '0.9375rem',
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem',
    },
  },
  orderPriceInfoBodyItemValue: {
    fontWeight: 700,
    fontSize: '1rem',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
    },
  },
  orderPriceTotal: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    padding: theme.spacing(2),
    textAlign: 'center',
    fontWeight: 700,
    backgroundColor: theme.palette.grey[50],
    fontSize: '1.125rem',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
      fontSize: '1rem',
    },
  },
  orderItemInfoTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(1.5),
    fontSize: '1.25rem',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.125rem',
      marginBottom: theme.spacing(1),
    },
  },
  orderImgHolder: {
    width: '30%',
    borderRadius: theme.shape.borderRadius * 2,
    overflow: 'hidden',
    position: 'relative',
    paddingTop: '32%',
    boxShadow: elevatedSurfaceBoxShadow,
    transition: transition,
    '&:hover': {
      boxShadow: elevatedSurfaceBoxShadow,
      transform: 'scale(1.02)',
    },
    [theme.breakpoints.down('sm')]: {
      width: '35%',
      borderRadius: theme.shape.borderRadius,
    },
    [theme.breakpoints.down('xs')]: {
      width: '40%',
    },
  },
  orderBgHolder: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  orderItemPropItem: {
    marginBottom: theme.spacing(1),
  },
  orderItemPropLabel: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    display: 'inline-block',
    marginRight: theme.spacing(1.5),
    fontSize: '0.9375rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem',
      marginRight: theme.spacing(1),
    },
  },
  orderItemPropDescription: {
    color: theme.palette.text.secondary,
    fontSize: '0.9375rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem',
    },
  },
  orderTypographyHolder: {
    width: '70%',
    paddingLeft: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      width: '65%',
      paddingLeft: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      width: '60%',
      paddingLeft: theme.spacing(1.5),
    },
  },
  orderDescription: {
    //paddingTop: theme.spacing(2)
  },
  orderDescriptionTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    marginBottom: theme.spacing(1.5),
    marginTop: theme.spacing(2),
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1),
    },
  },

  orderDescriptionText: {
    fontSize: '0.9375rem',
    lineHeight: 1.8,
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem',
      lineHeight: 1.75,
    },
  },
  orderItemInfoTitleHolder: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(4),
    gap: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(3),
      gap: theme.spacing(2),
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      marginBottom: theme.spacing(2.5),
      gap: theme.spacing(1.5),
      '& > div:first-child': {
        width: '100%',
        paddingTop: '50%',
      },
      '& > div:last-child': {
        width: '100%',
        paddingLeft: 0,
      },
    },
    '& img': {
      display: 'block',
      width: '100%',
      height: 'auto',
    },
  },
  orderItemInfoDate: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8125rem',
    },
  },
  orderItemInfoBlockTitle: {
    fontWeight: 700,
    fontSize: '1.125rem',
    marginBottom: theme.spacing(1.5),
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      marginBottom: theme.spacing(1.25),
    },
  },
  orderItemInfoBlockWrapper: {
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2.5),
    },
  },
  orderItemInfoBlock: {
    borderRadius: theme.shape.borderRadius * 2,
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: elevatedSurfaceBoxShadow,
    backgroundColor: theme.palette.background.paper,
    transition: transition,
    '&:hover': {
      boxShadow: elevatedSurfaceBoxShadow,
    },
    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.shape.borderRadius,
    },
  },
  orderItemInfoBlockItem: {
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(1.25),
      flexDirection: 'column',
      gap: theme.spacing(0.5),
    },
  },
  orderItemInfoBlockItemLabel: {
    color: theme.palette.text.secondary,
    fontSize: '0.9375rem',
    display: 'block',
    marginRight: theme.spacing(2),
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem',
      marginRight: 0,
      marginBottom: theme.spacing(0.25),
    },
  },
  orderItemInfoBlockItemValue: {
    fontWeight: 600,
    fontSize: '0.9375rem',
    maxWidth: '500px',
    textAlign: 'right',
    color: theme.palette.text.primary,
    wordBreak: 'break-word',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.875rem',
      textAlign: 'left',
      maxWidth: '100%',
    },
  },
  buttonBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    width: '100%',
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(3),
    borderTop: `2px solid ${theme.palette.divider}`,
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(2),
      justifyContent: 'center',
    },
    '& .MuiButton-root': {
      borderRadius: theme.shape.borderRadius * 2,
      padding: theme.spacing(1.25, 3),
      fontSize: '1rem',
      fontWeight: 600,
      textTransform: 'none',
      minWidth: 200,
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(1.15, 2.5),
        fontSize: '0.9375rem',
        minWidth: 180,
      },
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(1, 2),
        fontSize: '0.875rem',
        minWidth: 160,
      },
    },
  },

  //Modal
  orderModalWrapper: {},
  orderModal: {},
  paper: {
    position: 'absolute',
    width: '100%',
    maxWidth: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: elevatedSurfaceBoxShadow,
    padding: theme.spacing(3, 4),
    borderRadius: theme.shape.borderRadius * 2,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2.5, 3),
      borderRadius: theme.shape.borderRadius,
      maxWidth: '95%',
    },
    '&:focus': {
      outline: 'none',
    },
  },
  fullScreen: {
    width: '100%',
    height: '100%',
  },
  modal: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  closeIcon: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.text.secondary,
    padding: theme.spacing(0.5),
    borderRadius: '50%',
    transition: transition,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      color: theme.palette.text.primary,
      transform: 'rotate(90deg)',
    },
  },
  modalImgWrapper: {
    padding: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  modalImgHolder: {
    maxWidth: 350,
    marginRight: 'auto',
    marginLeft: 'auto',
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    boxShadow: elevatedSurfaceBoxShadow,
    '& img': {
      display: 'block',
      width: '100%',
      height: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  modalBtnBlock: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
    maxWidth: 350,
    marginRight: 'auto',
    marginLeft: 'auto',
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      maxWidth: '100%',
      '& button': {
        width: '100%',
      },
    },
    ['@media print']: {
      display: 'none',
    },
  },
  modalDownloadBtn: {
    marginRight: 0,
    borderRadius: theme.shape.borderRadius * 2,
    fontWeight: 600,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      borderRadius: theme.shape.borderRadius,
    },
  },
}))
